import { Component, OnInit } from '@angular/core';
import { Observable, from, combineLatest } from 'rxjs';
import { AngularFireStorage } from '@angular/fire/storage';
import { switchMap } from 'rxjs/operators';

@Component({
  selector: 'app-image-carousel',
  templateUrl: './image-carousel.component.html',
  styleUrls: ['./image-carousel.component.scss']
})
export class ImageCarouselComponent implements OnInit {
  slides$: Observable<Array<string>>;
  constructor(private firebaseStorage: AngularFireStorage) {}

  ngOnInit(): void {
    this.slides$ = from(
      this.firebaseStorage.storage.ref('home-page-carousel').listAll()
    ).pipe(
      switchMap(images =>
        combineLatest(images.items.map(item => from(item.getDownloadURL())))
      )
    );
  }
}
